import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { DSDatePicker } from '@demandstar/components/inputs/date-picker';

import { Assert, isTodayOrEarlier } from '../../../../utils/helpers';
import { AddRequiredDocumentsPanel } from './AddRequiredDocumentsPanel';
import { requiredDocLabels } from '../add-vendor-docs/constants';
import { requiredDocumentInstructions } from './constants';
import { RequiredDocumentResponseGetAPIResponse } from 'src/types';
import { RequiredDocumentsTable } from './RequiredDocumentsTable';
import { useRequiredDocumentResponses } from '../../../../shared/hooks';
import { useRequiredDocumentTypes } from '../../../../shared/hooks/award-bid/useRequiredDocumentTypes';

const AllDocDescriptionWrapper = styled.div`
  padding-bottom: 2rem;
`;

const UpdateAllDatesWrapper = styled.div`
  padding-bottom: 2rem;
`;

/**
 * Required Document List table with editable/deletable rows,
 * a date picker to change all row dates,
 * and a toggle button to allow addition of new Required Documents
 */
export function RequiredDocumentsPanel() {
  // Local state
  const [defaultDate, setDefaultDate] = useState<Dayjs | null>(dayjs());

  // Hooks
  const { requiredDocumentResponses: requiredDocResponses, setRequiredDocumentResponses } =
    useRequiredDocumentResponses();
  const { refreshRequiredDocTypes } = useRequiredDocumentTypes();

  // useEffect Hooks

  useEffect(() => {
    refreshRequiredDocTypes();
  }, [refreshRequiredDocTypes]);

  // Functions

  /** Update all requiredDocs with the general DatePicker
   * @param {string} value - the selected date in ISO
   */
  function changeAllDueDates(value: Dayjs | null) {
    setDefaultDate(value);
    Assert(!!value, 'dueDate should be valid', 'RequiredDocumentsPanel');
    const updatedRequiredDocs = [...requiredDocResponses].map(reqDoc => {
      return { ...reqDoc, dueDate: value.format() } as RequiredDocumentResponseGetAPIResponse;
    });
    setRequiredDocumentResponses(updatedRequiredDocs);
  }

  return (
    <>
      <AllDocDescriptionWrapper>{requiredDocumentInstructions}</AllDocDescriptionWrapper>

      <UpdateAllDatesWrapper>
        <DSDatePicker
          label={requiredDocLabels.updateAllDueDates}
          disabledDate={isTodayOrEarlier}
          onChange={changeAllDueDates}
          name={'update-all-dates'}
          value={defaultDate}
        />
      </UpdateAllDatesWrapper>

      <RequiredDocumentsTable />

      <AddRequiredDocumentsPanel />
    </>
  );
}
